import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { safeSetItem } from '../utils/storageUtils';
import rootReducer from './reducers';

// Custom storage that handles quota exceeded errors
const customStorage = {
  ...storage,
  setItem: (key, value) => {
    return new Promise((resolve, reject) => {
      try {
        safeSetItem(key, value);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },
};

const persistConfig = {
  key: 'root',
  storage: customStorage,
  // Only persist essential data to avoid quota issues
  whitelist: ['user', 'address'], // Persist user and address data
  // Alternative: use blacklist to exclude large data
  // blacklist: ['products', 'categories', 'cart', 'temporaryData', 'cache'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
      serializableCheck: false, // Disable in development to avoid performance warnings
      immutableCheck: false,
    });
  },
});

export const persistor = persistStore(store);

export const clearPersistedStorage = () => {
  persistor.purge(); // This clears the persisted storage
};

export default store;
